import { useEffect, useState } from "react";
import { AnimatePresence, motion, useReducedMotion } from "framer-motion";
import { QUOTES } from "@/content/quotes";

const INTERVAL = 6500;
const shuffled = () => {
  const a = [...QUOTES];
  for (let n = a.length - 1; n > 0; n--) {
    const j = Math.floor(Math.random() * (n + 1));
    [a[n], a[j]] = [a[j], a[n]];
  }
  return a;
};

export const HeroQuotes = () => {
  const [quotes] = useState(shuffled);
  const [i, setI] = useState(0);
  const [paused, setPaused] = useState(false);
  const reduce = useReducedMotion();

  useEffect(() => {
    if (paused || quotes.length < 2) return;
    const t = setTimeout(() => setI((n) => (n + 1) % quotes.length), INTERVAL);
    return () => clearTimeout(t);
  }, [i, paused, quotes.length]);

  const q = quotes[i];
  return (
    <motion.figure
      className="hero-quotes"
      initial={reduce ? false : { opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.9, delay: 0.8, ease: [0.22, 1, 0.36, 1] }}
      onMouseEnter={() => setPaused(true)}
      onMouseLeave={() => setPaused(false)}
      aria-live="polite"
      data-testid="hero-quotes"
    >
      <span className="quote-mark" aria-hidden="true">“</span>
      <div className="quote-stack">
        <AnimatePresence initial={false}>
          <motion.div
            key={i}
            className="quote-slide"
            initial={reduce ? false : { opacity: 0, y: 18, filter: "blur(6px)" }}
            animate={{ opacity: 1, y: 0, filter: "blur(0px)" }}
            exit={{ opacity: 0, y: -14, filter: "blur(6px)" }}
            transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
          >
            <blockquote data-testid="hero-quote-text">{q.text}</blockquote>
            <figcaption data-testid="hero-quote-author">— {q.author}</figcaption>
          </motion.div>
        </AnimatePresence>
      </div>
      <div className="quote-dots" role="tablist" aria-label="Choose quote">
        {quotes.map((_, n) => (
          <button
            key={n}
            type="button"
            role="tab"
            aria-selected={n === i}
            aria-label={`Quote ${n + 1}`}
            className={n === i ? "is-on" : ""}
            onClick={() => setI(n)}
            data-testid={`hero-quote-dot-${n}`}
          />
        ))}
      </div>
    </motion.figure>
  );
};
